import React, { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Col, Row, Input, Form, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";

import "./index.css";
import { login } from "../../store/slices/authSlice";

const LoginScreen = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const auth = useSelector((state) => state.auth);
  
  const onSubmit = () => {
    dispatch(login({ email: username, password: password }))
      .unwrap()
      .then((result) => navigate("/Sureler"))
      .catch(() => {
        message.error("Kullanıcı adı şifrenizi kontrol ediniz");
      });
  };

  return (
    <>
      <Row justify="center" align="middle" style={{ height: "100vh" }}>
        <Col span={4}>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            onFinish={onSubmit}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Kullanıcı Adı Boş Bırakılamaz",
                },
                {
                    type: 'email',
                    message: "Lütfen uygun e-posta adresi giriniz",
                  },
              ]}
            >
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Kullanıcı Adı"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Şifre boş bırakılamaz",
                },
              ]}
            >
              <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Şifre"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={auth.loading}
              >
                Giriş Yap
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
};
export default LoginScreen;
